import React, { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'

import {downloadFileNew, projectContext, loadingContext, intentsContext, urlValue, unfolder, onImportExcelAsync, openAlert, useTranslate} from '../lib'
import SideBar from '../components/SideBar'
//import LoaderWidget from 'tpco_widget_loader';
import { EditIntent, IntentDetail, NewIntent } from '../components/intents'

import '../styles/answerCRUD.scss'
import '../styles/answers.scss'
import { customModal } from '../styles/customModal'
import TitleBar from "../components/TitleBar";
import CheckBox2 from '../components/CheckBox2'
import Loading from '../components/Loading'
import ChatBot2 from "../components/ChatBot2";
import BoxInfo from '../components/common/BoxInfo'
import { Tooltip } from 'react-tooltip'
import Button from '../components/provider/button/button.jsx'

export default function Intents() {
  const [isModalOpen, setIsModalOpen] = useState({ delete: false, code: false })
  const intentsCtx = useContext(intentsContext);
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [selectedAnswer, setSelectedAnswer] = useState({ content: {} })
  const [sidePanel, setSidePanel] = useState('detail')
  const [refresh, setRefresh] = useState(0)
  const [answers, setAnswers] = useState([])
  const ref = useRef(null)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useContext(loadingContext)
  const [sort, setSort] = useState('asc')
  const { t } = useTranslate();
  // const [alert, setAlert] = useState({title: '', visible: false})

  const getAllItents = (name_intent) => {
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/project/${selectedProject.id}/intents`,
      headers: {
        'user': id,
        'access-token': token,
        'Content-Type': 'application/json',
      },
    })
      .then(function (response) {
        intentsCtx.updateState(response.data, "answers");

        setAnswers(response.data)
        if (name_intent === "all") {
          setSelectedAnswer(response.data[0])
          setSidePanel('edit')
        } else if (name_intent) {
          setSelectedAnswer(response.data.find(x => x.name === name_intent))
          setSidePanel('edit')
        } else {
          setSidePanel('new')
        }
        setLoading(false)

      })
      .catch(function (error) {
        console.log(error)
        setLoading(false)
      })
  }
  useEffect(() => {
    getAllItents("all");
  }, [refresh])

  function handleAnswer(answer) {
    setSidePanel('edit')
    intentsCtx.updateState(answer, "answerSelected");
    setSelectedAnswer(answer)
  }

  function openModal(answer) {
    setIsModalOpen({ delete: true, code: false })
    setSelectedAnswer(answer)
  }

  const deleteAnswer = () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let ccms_name = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').ccms_name
    
    if (selectedAnswer.displayName?.toUpperCase() == 'DEFAULT FALLBACK INTENT') {
      alert(t('alerts.defaultFallbackIntent'))
      setIsModalOpen({ delete: false, code: false })      
    }
    else {    
      setLoading(true)  
      axios({
        method: 'post',
        url: `${urlValue}/studio/project/${selectedProject.id
          }/intent/${selectedAnswer.name.slice(
            selectedAnswer.name.lastIndexOf('/') + 1,
            selectedAnswer.name.length
          )}/delete`,
        headers: {
          'user': id,
          'access-token': token,
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
        data: JSON.stringify({
          intentName: selectedAnswer.name,
          trainingPhrases: selectedAnswer.trainingPhrases.map(e => e.parts[0].text),
          languageCode: selectedProject?.metadata?.language?.slice(0, 2),
          displayName: selectedAnswer.displayName,
          user_id: id,
        }),
      })
      .then(function (response) {

        setSidePanel('new')
        setSelectedAnswer({ content: {} })

        setRefresh(refresh + 1)
        setIsModalOpen({ delete: false, code: false })
        setTimeout(() => {
          getAllItents("all")
        }, 3000)
      })
      .catch(function (error) {
        console.log(error)

        setIsModalOpen({ delete: false, code: false })
        setTimeout(() => {
          getAllItents("all")
        }, 3000)
      })

    }

  }
  

  const [intentsDelete, setIntentsDelete] = useState([]);
  const [modalDelete, setModalDelete] = useState(false);
  const selectForDelete = (e, item) => {
    if (e.target.checked) {
      setIntentsDelete([...intentsDelete, item])
    } else {
      setIntentsDelete(intentsDelete.filter(x => x.id !== item.id));
    }
  }

  const selectAll = (e) => {
    if (e.target.checked) {
      document.querySelectorAll("#intent-all input[type='checkbox']").forEach((item) => {
        item.checked = true;
      })
    } else {
      document.querySelectorAll("#intent-all input[type='checkbox']").forEach((item) => {
        item.checked = false;
      })
    }
  }

  const deleteMultiple = async () => {
    try {
      if (intentsDelete.length > 0) {

        let newArrayIntentsToDelete = [];
        let uniqueObject = {};
        let objTitle = '';

        for (let i in intentsDelete) {
          // Extraction the title
          objTitle = intentsDelete[i]['id'];

          // Here we use the title as the index
          uniqueObject[objTitle] = intentsDelete[i];
        }

        for (let i in uniqueObject) {
          newArrayIntentsToDelete.push(uniqueObject[i]);
        }

        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
        let result;
        for (let i = 0; i < newArrayIntentsToDelete.length; i++) {
          if (newArrayIntentsToDelete[i].displayName?.toUpperCase() != 'DEFAULT FALLBACK INTENT') {
            result = await axios.post(
              `${urlValue}/studio/project/${selectedProject.id}/intent/${newArrayIntentsToDelete[i].name.slice(
                newArrayIntentsToDelete[i].name.lastIndexOf('/') + 1,
                newArrayIntentsToDelete[i].name.length)}/delete`
              , {
                headers: {
                  'user': id,
                  'access-token': token,
                  'X-CSRF-Token': csrfToken
                },
                withCredentials: true,
              });
          }
        }
        getAllItents("all")
        setModalDelete(false)
        setTimeout(() => {
          getAllItents("all")
        }, 3000)
        return result;
      }
    } catch (error) {
      setModalDelete(false)
      setTimeout(() => {
        getAllItents("all")
      }, 3000)
    }
  }

  const sortElementsChange = (e) => {
    setSort(e.target.value);
  }

  const sortElements = () => {
    let sortOrder = sort;
    let result;

    switch (sortOrder) {
      case 'asc':
        result = (a, b) => a.displayName > b.displayName ? 1 : -1;
        break;
      case 'desc':
        result = (a, b) => a.displayName < b.displayName ? 1 : -1;
        break;
    }

    return result;
  }

  useEffect(() => {
    document.querySelectorAll("#intent-all input[type='checkbox']").forEach((item) => {
      item.checked = false;
    })
  }, [intentsCtx.state.answers])

  //const [IntentstExcel, setIntentstExcel] = useState([]);
  const [loadingUpload, setLoadingUpload] = useState(false)


  const uploadMaxive = async (IntentstExcel) => {

    if (!loadingUpload && IntentstExcel.length > 0 && IntentstExcel.length <= 101) {
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
      let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken

      setLoadingUpload(true)
      setTimeout(async () => {

        const DatosFormat = [...IntentstExcel].map((item, index) => {
          let split = item.Training_Phrases.split("--");
          split = split.filter(x => x.trim() !== "");
          const fraseSelecionada = split.find(x => x[0] === "*");
          split = split.map(ph => (ph.replace("*", "")?.trim()));
          return { ...item, Training_Phrases: split, CompliancePhare: fraseSelecionada.replace("*", "")?.trim() };
        });
        for (var i = 0; i < DatosFormat.length; i++) {

          let CategoryExcel = 1;
          switch (DatosFormat[i].Category) {
            case "Compliance":
              CategoryExcel = 1;
              break;
            case "Resolution":
              CategoryExcel = 2;
              break;
            case "Conversation":
              CategoryExcel = 3;
              break;

            default:
              break;
          }
          const dataSend = JSON.stringify({
            displayName: DatosFormat[i].Name?.trim(),
            trainingPhrasesParts: DatosFormat[i].Training_Phrases,
            languageCode: selectedProject?.metadata?.language?.slice(0, 2),
            compliance_type: CategoryExcel,
            compliance_phare: DatosFormat[i].CompliancePhare,
            inputContext: DatosFormat[i].InputContext,
            outputContext: DatosFormat[i].OutputContext,
          })

          const rest = await axios.post(`${urlValue}/studio/project/${selectedProject.id}/intent`,
            dataSend,
            {
              headers: {
                'access-token': token,
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': true,
                'X-CSRF-Token': csrfToken
              },
              withCredentials: true,

            })
        }
        setLoadingUpload(false)
        window.location.reload();
      }, 2000)

    } else {
      alert(t('alerts.projectExcelLimit2'))
    }

  }
  const prepareExcel = async (file) => {
    const DatosExcel = await onImportExcelAsync(file, ['Name', 'Category', 'Training_Phrases', 'InputContext', 'OutputContext']);
    //setIntentstExcel(DatosExcel);
    uploadMaxive(DatosExcel);

  }
  useEffect(() => {
    console.log('selectedProject.id', selectedProject.id)
    //LoaderWidget.Loader(selectedProject.id, '#widget-loader');
  }, []);


  return (
    <div>
      <div id="widget-loader" style={{ zIndex: 3000 }} />
      {/* <ChatBot2 project={selectedProject} /> */}
      <section className="container-answers general-container" id="container">
        <SideBar active={'Intents'} />
        <div className="row_primary">
          <div className="con_title_bar">
            <TitleBar />
          </div>
          <div className="con_header">
            <div className="header">
              <div className="title">
                <div className="intents">
                  <div className="project-name-container m-1">
                    <div className="icon"></div>
                    <h2>{selectedProject.name}</h2>
                  </div>
                  <div className="separator">-</div>
                  <div>
                    <h1 className={'m-1'}>{t('intents.intents')}</h1>
                  </div>

                </div>

                <div className="head justify-end flex-1">
                  <div className="flex items-center justify-end">
                    <div   onClick={() => { downloadFileNew("FormatIntents.xlsx") }} className="a-download trans btn-excel" style={{ cursor: 'pointer',marginLeft: 10 }}   >
                      <img src="/icons/download-icon.svg" alt="newAns" style={{ width: 15 }} />
                      <span>{t('intents.intentTemplate')}</span>
                      <BoxInfo
                        id="downloadexc-tp"
                        titleClass='mr-0-1 color-label f-16  title-intent'
                        title=""
                        place="top"
                        containerClass='mL-0-1 z-15 '
                        render={t('intents.intentTemplateTooltip')}
                      />
                    </div>
                    
                    
                    <div className="upload-excel btn-excel upload-btn trans ml-2">

                      {loadingUpload ? <Loading /> : <>
                        <img src="/icons/excel.svg" alt="newAns" style={{ width: 19 }} />
                        <label> {t('menu.uploadExcel')}</label>

                      </>}

                      <input type='file' accept='.xlsx, .xls' onChange={prepareExcel} />

                      <BoxInfo
                        id="uploadexc-tp"
                        titleClass='mr-0-1 color-label f-16  title-intent'
                        title=""
                        place="top"
                        containerClass='mL-0-1 z-15 '
                        render={t('intents.uploadExcelTooltip')}
                      />
                    </div>
                    
                  </div>

                  <Button 
                    type="button"
                    id='newbtn-tp'
                    label={t('intents.newIntents')}
                    onClick={() => setSidePanel('new')}
                    className='buttonE ml-3'
                    content={t('intents.createTooltip')}
                  />

                  <Button 
                    type="button"
                    id='delete-tp'
                    label={t('common.delete')}
                    onClick={() => setModalDelete(true)}
                    className='buttonH ml-2 btn-top btn-top-new'
                    style={{fontSize: 13}}
                    content={t('intents.deleteIntentsTooltip')}
                  />

                </div>
              </div>

            </div>
            <div className="container-info">

              <div className="body-container">
                <div className="body left-c " id="intent-all">
                  <div className="flex flex-row items-center pb-2 ml-2">
                    <div className="home-search ml-3 bg-white d-flex flex-row align-items-center justify-space-between"
                         style={{ borderRadius: 20, backgroundColor: 'white', width: 200, border: '1px solid gray' }}>
                      <input
                        type="text"
                        placeholder={t('common.search')}
                        onChange={event => {
                          setSearch(event.target.value)
                        }}
                        className="p-2 home-search"
                        style={{ border: 'none', marginLeft: 7, maxWidth: 160, borderRadius: '20px' }}
                      />
                      <div className="p-1 pr-5 mt-1">
                        <img src="/icons/search.svg" style={{ width: 16, minWidth: 16, marginLeft: -8 }} alt='' />
                      </div>
                    </div>

                    <div className="flex-1 d-flex flex-row  items-center justify-end ">
                      <label htmlFor="sort" className='title-search'>{t('common.organize')} :</label>
                      <select onChange={sortElementsChange} name="" id="sort" className="select-nesting"
                        style={{ border: '1px solid gray', fontSize: 13, borderRadius: 20, marginLeft: 8,
                          padding: '0 20px', minWidth: 100, backgroundPositionX: "80%", height: 30 }}>
                        <option value="asc" selected style={{ padding: 5 }}>{t('common.asc')} </option>
                        <option value="desc" style={{ padding: 5 }}>{t('common.desc')} </option>
                      </select>
                    </div>
                  </div>

                  <div className="elements sm3-h-80vh scroll-panel-left" ref={ref}>
                    {intentsCtx.state.answers.length > 0 &&
                      <div className='rounded-md flex items-center' style={{ marginLeft: 20, marginRight: 20, paddingLeft: 15 }}>
                        <CheckBox2 onChange={(e) => selectAll(e)} default={false} id={`ck-all-proj`} text="" />
                        <labe><b></b>{t('intents.selectAll')}</labe>
                      </div>}
                    {intentsCtx.state.answers
                      .filter(value => {
                        if (search == '') {
                          return value
                        } else if (
                          value.displayName.toLowerCase().includes(search.toLowerCase())
                        ) {
                          return value
                        }
                      })
                      .sort(sortElements())
                      .map((answer, index) => (
                        <div className="element" key={index}>
                          <div className="answer">
                            <CheckBox2 onChange={(e) => selectForDelete(e, answer)} default={false} id={`${answer.name}`} text="" />
                            {/* <div className="icon"></div> */}
                            <div className='list-color' >{answer.displayName}</div>
                          </div>
                          <div className="options_container">
                            <img
                              id={`delete-tp-${index}`}
                              src="/icons/trash.png"
                              alt="trash"
                              onClick={() => openModal(answer)}
                            />
                            <Tooltip anchorSelect={`#delete-tp-${index}`} content={t('common.delete')} place="top" />
                            <div id={`Setting-tp-${index}`} className="more" onClick={() => handleAnswer(answer)}>
                              <div style={{ color: "#707070" }} >{t('common.settings')}</div>
                              <img src="/icons/Expand_left.svg" alt="expandLeft" />
                            </div>
                            <Tooltip anchorSelect={`#Setting-tp-${index}`} content={t('intents.settingsTooltip')} place="top" />
                          </div>

                        </div>
                      ))}
                  </div>
                  {/* <div className="count">
                    <h4>1 - {ref.current ? ref.current.children.length - 1 : 1}</h4>
                  </div> */}
                </div>

                <div className="container-edit right-c scroll-panel-rigth-intents">

                  {sidePanel == 'edit' ? (
                    <EditIntent
                      update={(name) => { getAllItents(name) }}
                      selectedAnswer={selectedAnswer}
                      setSidePanel={setSidePanel}
                      refresh={refresh}
                      setRefresh={setRefresh}
                      setSelectedAnswer={setSelectedAnswer}
                    />
                  ) : sidePanel == 'new' ? (
                    <NewIntent
                      update={() => getAllItents()}
                      setSidePanel={setSidePanel}
                      refresh={refresh}
                      setRefresh={setRefresh}
                    />
                  ) : null


                  }
                </div>


              </div>

            </div>
            {/* intentsCtx.state.answers && <IntentDetail
                      refresh={() => { getAllItents() }}
                      selectedAnswer={selectedAnswer}
                      setSelectedAnswer={setSelectedAnswer}
                      setSidePanel={setSidePanel}  />*/}
          </div>
        </div>

      </section>
      <Modal isOpen={isModalOpen.delete} style={customModal} ariaHideApp={false}>
        <div id="container-modal" className='modal-c'>
          <img src="/icons/alert.png" />
          <h1>{t('intents.deleteIntent')}</h1>
          <h1>{t('menu.deleteConfirmQuestion')}</h1>
          <div className="buttons-modal">
            <button
              onClick={() => setIsModalOpen({ delete: false, code: false })}
              className="cancel btn-modal-cancel"
            >
              {t('common.cancel')}
            </button>
            <button onClick={deleteAnswer} className="accept">
              {t('common.accept')}
            </button>
          </div>
        </div>
      </Modal>

      <Modal isOpen={modalDelete} style={customModal} ariaHideApp={false}>
        <div id="container-modal" className='modal-c'>
          <img src="/icons/alert.png" alt='' />
          <h1>{t('intents.deleteIntents')}</h1>
          <h1>{t('menu.deleteConfirmQuestion')}</h1>
          <div className="buttons-modal">
            <button
              onClick={() => setModalDelete(false)}
              className="cancel btn-modal-cancel"
            >
              {t('common.cancel')}
            </button>
            <button onClick={() => { deleteMultiple() }} className="accept">
              {t('common.accept')}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )


}

